import type { RouteRecordRaw } from 'vue-router';

export const posRoutes: RouteRecordRaw[] = [
  {
    path: 'pos',
    name: 'pos',
    component: () => import('./pages/PosPage.vue'),
    meta: { title: 'POS', requiresAuth: true, permission: 'create_sales' },
  },
];
